module.exports = __webpack_public_path__ + "img/Slice1.1b893305.png";